/* eslint-disable no-unused-vars */

import axios from 'utils/axios';
import CypherClass from '../../config/Cypher.js';
const Cypher = new CypherClass();

export async function GetRouteRules(route) {
    const response = await axios.get(`/sales/getRouteRules`, {
        params: {
            route: route,
        }
      });

    const decrypted = Cypher.decrypt(response.data);
    return decrypted.data;
}